import useWebsiteId from '@hooks/useWebsiteId'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export function useClearTable() {
  const mutate = useMutate()
  const websiteId = useWebsiteId()

  return {
    clearTable: async () => {
      await mutate({
        mutation: gql`
          mutation setUserPreferencesClearTable($websiteId: ID, $tableName: String) {
            preferences: setUserPreferences(websiteId: $websiteId, tableName: $tableName) {
              _id
              tableName
            }
          }
        `,
        variables: {websiteId, tableName: null}
      })
      sessionStorage.removeItem('onTable')
      sessionStorage.removeItem('orderGroupId')
      sessionStorage.removeItem('onTableModal')
    }
  }
}
